import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter, Route, Routes, Navigate } from 'react-router-dom';
import Prices from './pages/Prices';
import Nav from './components/Nav';
import NotFound from './pages/Notfound';
import Contact from './pages/Contact';
import About from './pages/About';
import Services from './pages/Services';
import Terms from './pages/Terms';
import Privacy from './pages/Privacy';
// import Reservations from './pages/ReservationsRefactored';
import Footer from './components/Footer';
import { startScrollReveal } from './utils/scrollReveal';

startScrollReveal();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter>
  <Nav/>
  <Routes>
    <Route path='/' Component={App}></Route>
    <Route path='/prices' Component={Prices}></Route>
    <Route path='/contact' Component={Contact}></Route>
    <Route path='/about' Component={About}></Route>
    <Route path='/services' Component={Services}></Route>
    <Route path='/reservations' element={<Navigate to="/" replace />}></Route>
    <Route path='/terms' Component={Terms}></Route>
    <Route path='/privacy' Component={Privacy}></Route>
    <Route path='*' Component={NotFound}></Route>
  </Routes>
  <Footer/>
  </BrowserRouter>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
